exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-list-option{width:100%;min-height:38px;display:flex;align-items:center;margin:0;padding:6px 0 6px 8px;border-bottom:1px solid #ddd}.radio-list-option .radio{margin:0}.radio-list-option .radio.styled label{display:flex;align-items:center;min-height:inherit}.radio-list-option label:after{top:inherit}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.radio-list-option .radio.styled label:after{top:3.5px}}", ""]);

// exports
